import {
  DocumentsGenerationStatus,
  Pagination,
  PdfGenerationCurrentProgress,
  PdfGenerationsOverview,
  Process,
  ProcessDocumentsList,
  User,
  UserAsset,
  UserProcess,
  UserProcessChange,
  ValidationConfig,
} from '@interfaces';

export type ManagementState = Readonly<{
  usersProcesses: Partial<UserProcess>[];
  usersProcessesPagination: Pagination;

  user: User;

  processesOfUser: Partial<UserProcess>[];
  processesOfUserPagination: Pagination;

  userProcess: UserProcess;
  userProcessBasicData: Partial<UserProcess>;
  userProcessDocuments: {
    userProcessId: string;
    processDocumentsList: ProcessDocumentsList;
    documentsGenerationStatus: DocumentsGenerationStatus;
    pdfGenerations: PdfGenerationsOverview;
    pdfGenerationCurrentProgress: PdfGenerationCurrentProgress;
  };
  loadingDocuments: boolean;
  loadingSigningMode: boolean;
  itemsSentForFinalReview: UserAsset[];
  loadingItemsInReview: boolean;

  decisionDocuments: UserAsset[];
  loadingDecisionDocuments: boolean;

  loadingUserProcessChanges: boolean;
  userProcessChanges: {
    userProcessId: string;
    changes: UserProcessChange[];
  };

  loadingUserActivity: boolean;
  userActivity: UserProcessChange[];
  userActivityPagination: Pagination;

  processWithDocuments: Process;
  loadingProcess: boolean;

  loading: boolean;
  loadingBasicData: boolean;
  loadingFullPersonalDetails: boolean;
  errorMessage: string;

  loadingFileData: boolean;

  personalDetailsValidationConfig: { userProcessId: string; all: ValidationConfig; members: ValidationConfig };
  anyMyProcessesMissingAssistant: boolean;
  checkingMissingAssistantInProgress: boolean;

  sendingEmail: boolean;
}>;

export const defaultPagination = {
  all: 0,
  limit: 50,
  offset: 0,
  orderBy: 'updatedAt',
  orderDir: 'desc',
};

export const initialState: ManagementState = {
  loading: false,
  errorMessage: null,
  usersProcesses: null,
  usersProcessesPagination: { ...(defaultPagination as Pagination) },
  processesOfUser: null,
  processesOfUserPagination: { ...(defaultPagination as Pagination) },
  user: null,
  userProcess: null,
  userProcessBasicData: null,
  userProcessDocuments: {
    userProcessId: null,
    processDocumentsList: null,
    documentsGenerationStatus: null,
    pdfGenerations: null,
    pdfGenerationCurrentProgress: null,
  },
  itemsSentForFinalReview: [],
  loadingItemsInReview: false,
  decisionDocuments: [],
  loadingDecisionDocuments: false,
  loadingDocuments: false,
  loadingSigningMode: false,
  loadingUserProcessChanges: false,
  userProcessChanges: {
    userProcessId: null,
    changes: null,
  },
  loadingUserActivity: false,
  userActivity: [],
  userActivityPagination: { ...(defaultPagination as Pagination) },
  loadingFileData: false,
  processWithDocuments: null,
  loadingProcess: false,
  loadingFullPersonalDetails: false,
  personalDetailsValidationConfig: null,
  anyMyProcessesMissingAssistant: false,
  checkingMissingAssistantInProgress: false,
  loadingBasicData: false,

  sendingEmail: false,
};
